// ---------------------------------------------- modules import
import Embed from "@editorjs/embed";
import Header from "@editorjs/header";
import Paragraph from "@editorjs/paragraph";
import SimpleImage from "@editorjs/simple-image";

import { MenuIndex } from "../../../store/helpers/permissionHelper";
import { IPost } from "../../../store/post/common";

// ---------------------------------------------- editor tools
export const tools = {
  embed: Embed,
  header: {
    class: Header,
    config: {
      placeholder: "Enter your header"
    }
  },
  paragraph: {
    class: Paragraph,
    inlineToolbar: true
  },
  simpleImage: SimpleImage
};

export interface IAddFormProps {
  menuIndex: MenuIndex;
}

export interface IDetailsProps {
  menuIndex: MenuIndex;
}

export interface IListProps {
  menuIndex: MenuIndex;
}

export interface IPostProps {
  menuIndex: MenuIndex;
}

export interface IReaderListProps {
  menuIndex: MenuIndex;
}

export interface ISearchFormProps {
  criteria: { prop: string; keywords: string; category: string | null };
  categories: string[];
  onFilter: (criterion: string, value: string | null) => void;
}

export interface ISummaryProps {
  post: IPost;
}

export interface IUpdateFormProps {
  menuIndex: MenuIndex;
}
